module.exports = __webpack_public_path__ + "static/media/speakers_logos_Tencent.f601af78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Tencent.jpg
// module id = 279
// module chunks = 0